import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { inject, observer } from 'mobx-react';
import LoadingModal from '../modals/LoadingModal';

class LoadingCard extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

    }

    render() {
        // const {
        //     event_id,
        //     bytes32_id,
        //     start_time,
        //     team_one,
        //     team_two } = this.props;

        // const DoughnutData = {
        //     labels: [
        //         this.props.team_one,
        //         'Draw',
        //         this.props.team_two,
        //     ],
        //     datasets: [{
        //         data: [6300, 2600, 13400],
        //         backgroundColor: [
        //             '#FF0000',
        //             '#FFFFFF',
        //             '#2e693f',
        //         ],
        //         hoverBackgroundColor: [
        //             '#FF0000',
        //             '#FFFFFF',
        //             '#2e693f',
        //         ],
        //         borderColor: [
        //             'rgba(255, 255, 255, 0)',
        //             'rgba(255, 255, 255, 0)',
        //             'rgba(255, 255, 255, 0)',
        //         ],
        //     }]
        // };

        const { store } = this.props;
        const { router: { goTo } } = store;

        return (

            <LoadingModal />

        );
    }
}

export default inject('store')(observer(LoadingCard));


// WEBPACK FOOTER //
// ./src/components/appComponents/LoadingCard.js